export const INFO_CARD_COLOR = {
  white: '#ffffff',
  red: '#e40520',
  mint: '#DCF1D9',
};
